import React from 'react';

import { Select, SelectProps } from '@mantine/core';
import { GymWrite } from 'types';

export const TYPES: Array<GymWrite['gymType']> = [
  'Bootcamp',
  'Crossfit',
  'Dance',
  'Gym',
  'Gymnastics',
  'Martial',
  'Personal Training',
  'Pilates',
  'Yoga',
  'Other',
];

const GymTypeSelect = ({ ...selectProps }: Omit<SelectProps, 'data'>): JSX.Element => {
  return (
    <Select
      {...selectProps}
      data={TYPES as Array<string>}
      searchable
      nothingFound='Gym Type Not Found'
      maxDropdownHeight={100}
    />
  );
};

export default GymTypeSelect;
